export const ACTION_CODE = 'DEAL_TAGS' + '_ACTION';
